<template>
  <div class="bg-white bg-opacity-20 p-4 rounded-lg backdrop-blur-lg">
    <h3 class="text-sm font-medium text-white text-opacity-80">{{ title }}</h3>
    <div class="flex justify-between items-center">
      <p class="text-xl font-bold text-white mt-1">{{ value }}</p>
      <p>
        <div class="bg-white rounded-lg p-1">
          <img :src="image" class="w-6 h-6 object-contain" :alt="label" />
        </div>
      </p> 
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoCard',
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    image: { // Definido correctamente como prop
      type: String,
      required: true
    },
    label: { // También necesitas definir la prop 'label' si la usas en el alt
      type: String,
      required: true
    }
  }
}
</script>
